import React, { useRef } from "react";
import { Box, Grid, Container } from "@mui/material";
import {
  TopSection,
  MapLocation,
  EmailForm,
  SocialMediaIcons,
} from "../../components";
import SEOHead from "../../components/SEO/SEOHead";
import {
  generateOrganizationSchema,
  generateWebPageSchema,
  generateBreadcrumbSchema,
} from "../../utils/structuredData";
import styleVariables from "../../variables.module.scss";

const ContactPage: React.FC = () => {
  const formSectionRef = useRef<HTMLDivElement>(null);

  // Generate SEO data
  const organizationSchema = generateOrganizationSchema();
  const webPageSchema = generateWebPageSchema(
    "Contact Us - Brin's Handyman Services Ottawa",
    "Contact Brin's Handyman Services for professional home repairs, painting, plumbing, carpentry, and more in Ottawa. For specialized work requiring licensed professionals, we collaborate with certified contractors. Get a free estimate today.",
    "https://brinshandymanservices.ca/contact-us"
  );
  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: "Home", url: "https://brinshandymanservices.ca" },
    { name: "Contact Us", url: "https://brinshandymanservices.ca/contact-us" },
  ]);

  const scrollToForm = () => {
    formSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div>
      <SEOHead
        title="Contact Us - Brin's Handyman Services Ottawa"
        description="Contact Brin's Handyman Services for professional home repairs, painting, plumbing, carpentry, and more in Ottawa. For specialized work requiring licensed professionals, we collaborate with certified contractors. Get a free estimate today."
        canonical="/contact-us"
        structuredData={[organizationSchema, webPageSchema, breadcrumbSchema]}
      />
      <TopSection
        subTitle="GET IN TOUCH"
        mainTitle="Contact Us"
        content="Ready to start your next project? Contact Brin's Handyman Services today for an estimate. We're here to help with all your home improvement needs in Ottawa and surrounding areas."
        onContactClick={scrollToForm}
      />

      <Box sx={{ width: "100%", height: "400px" }}>
        <MapLocation />
      </Box>

      {/* Contact form and social media section */}
      <Box
        ref={formSectionRef}
        sx={{ backgroundColor: styleVariables.themeOrangeColor, py: 8 }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
              <Box
                sx={{ backgroundColor: styleVariables.themeOrangeColor, p: 4 }}
              >
                <EmailForm />
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                  gap: 2,
                }}
              >
                <SocialMediaIcons
                  color={styleVariables.themeGreyColor}
                  direction={{ xs: "row", md: "column" }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </div>
  );
};

export default ContactPage;
